{
  "acceptedFileFormats": "Only .docx, .pdf, .txt files are accepted.",
  "actionCompetenceGroup": "Action Competence Group",
  "actionDeadline": "Action Deadline",
  "actionDescription": "Action Description",
  "actionDuration": "Action Duration",
  "actionEarliestStart": "Action Earliest Start",
  "actionName": "Action Name",
  "actions": "Actions",
  "actionsAndProjects": "Actions & Projects",
  "actionsColon": "Actions: ",
  "actionsPerformerConstraints": "Actions Performer Constraints",
  "add": "Add",
  "addAdmin": "Add Admin",
  "addAdminTitle": "Add Admin",
  "addAnalyses": "Add analyses",
  "addAnalysis": "Add Analysis",
  "addAnalysisGroup": "Add an analysis group",
  "addChatbot": "Add chatbot",
  "addCompetenceGroup": "Add Competence Group",
  "addConstraint": "Add constraint",
  "addGreyTask": "Add a GreyTask",
  "addInstrument": "Add an Instrument",
  "addItemPlaceholder": "Add {{item}}...",
  "addLocation": "Add location",
  "addMaintenance": "Add maintenance",
  "addMember": "Add member",
  "addNewBundle": "Add New Bundle",
  "addNewMaintenanceFor": "Add new maintenance for {{assetName}}",
  "addNewTask": "Add a new task",
  "addOffsite": "Add OFFSITE",
  "addProjectGroup": "Add an project group",
  "addProjectTemplate": "Add Project Template",
  "addRepository": "Add repository",
  "addRow": "Add Row",
  "addSample": "Add sample",
  "addSamples": "Add samples",
  "addTeam": "Add team",
  "additionalInformation": "Additional Information",
  "administrators": "Administrators",
  "advanced": "Advanced",
  "allFilesProcessed": "All uploaded files have been processed",
  "allowMembersMoveOthersOperationalTasks": "Allow members to move others' operational tasks",
  "allowedCompetenceGroups": "Allowed Competence Groups",
  "allowedInstruments": "Allowed instruments",
  "amountOfSamples": "Amount of samples: {{count}}",
  "analyses": "Analyses",
  "analysesRelatedTo": "Analyses related to {{product}}",
  "analysis": "Analysis",
  "analysisAndSampleDone": "The analysis and sample is done",
  "analysisDefinition": "analysis definition",
  "analysisDesignTool": "Analysis Design Tool",
  "analysisDone": "The analysis is done",
  "analysisDraft": "Analysis DRAFT",
  "analysisGroup": "Analysis group",
  "analysisGroupName": "Analysis group Name",
  "analysisIsFlagged": "Analysis is flagged",
  "analysisMustContainTaskDefinition": "The analysis must contain a task definition",
  "analysisName": "Analysis Name",
  "analysisNameMustBeUnique": "Analysis Name must be unique",
  "analysisNotPlanned": "This analysis is not planned",
  "analysisPlanned": "The analysis is planned",
  "analysisTaskBundle": "Analysis Task Bundle {{index}}",
  "cdmoTargetedBundle": "Gather tasks by analysis name",
  "analysisTaskTimePerformerSamples": "Analysis Task - Time, Performer, Number of Samples",
  "analysisTasks": "analysis tasks",
  "analysisTasksToBundle": "Analysis Tasks to Bundle",
  "analysisTimePercentage": "Percentage of analysis-time relative to total time (A2T)",
  "anywhere": "Anywhere",
  "apiToken": "API token",
  "archiveMember": "Archive Member",
  "archived": "archived",
  "areYouSureConnection": "Are you sure you want to have this connection?",
  "areYouSureConnectionMode": "Are you sure you want to go into \"with connection\" mode? This will remove all current connections",
  "areYouSureDeleteAdmin": "Are you sure you want to delete this admin?",
  "areYouSureDiscardSimulation": "Are you sure you want to discard the changes made in simulation mode?",
  "areYouSurePublishSimulation": "Are you sure you want to publish the changes made in simulation mode?",
  "areYouSureReset": "Are you sure you want to reset? This will remove all nodes.",
  "areYouSureUnplanAllFutureActions": "Are you sure you want to unplan all future actions in this project?",
  "areYouSureWantToExit": "Are you sure you want to exit?",
  "arrival": "Arrival",
  "assetAddedOrRemoved": "Asset has been added or removed",
  "assetRequirementsForAsset": "Asset Requirements for Asset {{index}}",
  "assets": "Assets",
  "atLeast1LowercaseLetter": "at least 1 lowercase letter",
  "atLeast1Number": "at least 1 number",
  "atLeast1UppercaseLetter": "at least 1 uppercase letter",
  "atLeast8Characters": "at least 8 characters",
  "automaticImportConversionSheet": "Automatic {{type}} Import Conversion Sheet",
  "automaticSheetConfiguration": "Automatic Sheet Configuration",
  "availability": "Availability",
  "availableTimeOneWeek": "Available time one week: ",
  "avgAnalysisDuration": "Average analysis duration: ",
  "avgSampleBatchInterval": "Average sample batch interval: ",
  "avgSamplesAllocated": "Average number of samples allocated: ",
  "backlog": "Backlog",
  "booked": "Booked",
  "bookedBy": "Booked by",
  "byCompetenceGroup": "By Competence Group",
  "byDeadline": "By Deadline",
  "byGroup": "By Group",
  "byText": "By Text",
  "canBePerformedAnywhere": "Can be performed anywhere",
  "canOnlyBePerformedOnSite": "Can only be performed on site",
  "cancel": "Cancel",
  "cancelChanges": "Cancel Changes",
  "cannotUnlockStartedTasks": "You can't unlock this since one or more tasks are started/paused/finished",
  "changeLogs": "Change Logs",
  "changesHaveBeenMade": "Changes has been made, reload for new data",
  "chatbotGreeting": "Hi, I'm your AI CHATBOT, specialized in Plannertech & Librarian help documentation, and the data repositories you have imported.\nYou can also always reach out to our Human Support on pt@arnvind.com from 9-16 CET.\nHow can I help you? :-)",
  "chatbotName": "Chatbot Name",
  "chatbotPlaceholder": "Write a short description of how the chatbot should behave.",
  "chatbots": "Chatbots",
  "chattingWith": "Chatting with {{name}}",
  "chooseAction": "Choose Action",
  "chooseTask": "Choose Task",
  "chooseWhatToAdd": "Choose what to add",
  "cleanUp": "Clean up",
  "clear": "Clear",
  "clearConversation": "Clear the conversation",
  "clearDates": "Clear Dates",
  "clearTable": "Clear Table",
  "clickToSelectOtherFiles": "Click to select other files",
  "close": "Close",
  "closeMessage": "close message",
  "closePanel": "Close panel",
  "collaborator": "Collaborator",
  "collaborators": "Collaborators",
  "domain": "Domain",
  "color": "Color",
  "columnName": "Column Name",
  "companyWideChatbot": "Company-wide chatbot",
  "competenceAndInstrumentConstraints": "Competence and Instrument Constraints",
  "competenceGroup": "Competence Group",
  "competenceGroupNameExists": "A competence group with that name already exists",
  "competenceGroups": "Competence Groups",
  "competenceGroupsColon": "Competence Groups: ",
  "configuration": "Configuration",
  "confirm": "Confirm",
  "confirmArchivalOfMember": "Confirm archival of member: {{initials}}",
  "confirmClearTable": "Are you sure you want to clear the table?",
  "confirmDeleteAllData": "Confirming this will delete all {{type}} data. There is no going back, even with Simulation Mode.",
  "confirmDeleteAllUnplannedProjects": "Confirming this will delete all projects, which have no actions placed on the plan",
  "confirmDeleteAllUnplannedSamples": "Confirming this will delete all samples, which have no actions placed on the plan",
  "confirmDeleteCompetenceGroup": "Confirm deletion of competence group:",
  "confirmDeleteInstrument": "Are you sure you want to delete instrument: {{name}}?",
  "confirmDeleteMaintenance": "Are you sure you want to delete this maintenance?",
  "confirmDeleteSample": "Are you sure you want to delete this unplanned sample?",
  "confirmDeleteSampleInfo": "Confirming this will permanently delete the selected sample",
  "confirmDeletion": "Confirm deletion",
  "confirmFailSamples": "Are you sure you want to fail the selected samples?",
  "confirmFailSamplesInfo": "Confirming this will fail selected samples. A duplicate will be placed in the unplanned analysis menu",
  "confirmFailSamplesQuestion": "Are you sure you want to fail the selected samples?",
  "confirmShowPlannedSamplesInfo": "Confirming this will show planned samples",
  "confirmShowPlannedSamplesQuestion": "Are you sure you want to show planned samples?",
  "confirmSortByTime": "Are you sure you want to sort by time",
  "confirmUnplanAllFutureActions": "Are you sure you want to unplan all future actions in this project?",
  "confirmUnplanAllQuestion": "Are you sure you want to unplan all {{itemType}}?",
  "confirmUnplanSamplesInfo": "Confirming this will unplan selected samples. It will be placed in the unplanned analysis menu",
  "confirmUnplanSamplesQuestion": "Are you sure you want to unplan the selected samples?",
  "connectionCalculatedInWorkdays": "Connection calculated in workdays",
  "connectionCount": "Connection Count",
  "connections": "Connections",
  "connectionsAdvancedWarning": "(Using connections with deadline or earliest start on actions are for advanced users)",
  "connectionsPerformersOnly": "Connections are performers only - does not affect asset allocation",
  "contactArnvindSupport": "Please contact Arnvind support at pt@arnvind.com",
  "conversionSheet": "Conversion Sheet",
  "copyToClipboard": "copy to clipboard",
  "country": "Country",
  "create": "Create",
  "createANewColumn": "Create a new Column",
  "createAction": "Create Action",
  "createChatbot": "Create chatbot",
  "createEditChatbots": "Create/edit chatbots",
  "createEditRepositories": "Create/edit repositories",
  "createNewColumn": "Create a new Column",
  "createNewProject": "Create New Project",
  "createSingleAction": "Create Single Action",
  "createStage": "Create Stage",
  "createStandardAction": "Create Standard Action",
  "currentlyProcessingRepository": "Currently processing this repository",
  "daily": "Daily",
  "date": "Date",
  "dateUnavailable": "Date Unavailable",
  "day": "day",
  "dayS": "day(s)",
  "days": "day(s)",
  "daysBeforeExpirationWarning": "Days before expiration to show warning",
  "daysBetweenRecurrences": "Days Between Recurrences",
  "deadline": "Deadline",
  "deadlineColon": "Deadline: ",
  "deadlineDate": "Deadline date",
  "deadlineMustBeLaterThanEarliestStart": "Deadline has to be later than or equal to earliest start",
  "deadlineTime": "Deadline Time",
  "defaultChatbot": "Default chatbot",
  "delete": "Delete",
  "deleteAllTypeTestData": "Delete all {{type}} Test Data",
  "deleteAllUnplannedProjects": "Delete all Unplanned Projects",
  "deleteAllUnplannedSamples": "Delete all Unplanned Samples",
  "deleteColumn": "Delete Column",
  "deleteCompetenceGroup": "Delete Competence Group",
  "deleteCompetenceGroupWarning": "Deleting this will leave tasks in the following analyses without a Competence Group. Ensure replacement before removal.",
  "deleteConstraint": "Delete constraint",
  "deleteData": "Delete Data",
  "deleteInstrument": "Delete Instrument",
  "deleteInstrumentWarning": "It will also be deleted for other teams on this location.",
  "deleteProjects": "Delete Projects",
  "deleteSample": "Delete Sample",
  "deleteSamples": "Delete Samples",
  "deleteThisRow": "Delete this row",
  "description": "Description",
  "designTool": "Design Tool",
  "done": "Done",
  "draft": "draft",
  "dragAndDropFiles": "Drag 'n' drop files here, or click to select files",
  "dragAndDropFolders": "Drag 'n' drop folders here, or click to select specific files",
  "dropFilesHere": "Drop files here",
  "dropFoldersHere": "Drop the folders here...",
  "duplicate": "Duplicate",
  "durationHHMM": "Duration (HH:MM)",
  "earliestStart": "Earliest Start",
  "edit": "Edit",
  "editAction": "Edit Action",
  "editAdmin": "Edit Admin",
  "editAnalysisGroup": "Edit analysis group",
  "editAnalysisTask": "Edit Analysis-task",
  "editChatbot": "Edit chatbot",
  "editCompetenceGroup": "Edit Competence Group",
  "editConnectionFromTo": "Edit connection from {{from}} to {{to}}",
  "editConversation": "Edit Conversation",
  "editGroup": "Edit group",
  "editInstrument": "Edit Instrument",
  "editItem": "Edit {{item}}",
  "editLocationName": "Edit location name",
  "editMaintenanceFor": "Edit {{name}} for {{assetName}}",
  "editMember": "Edit member",
  "editOffsite": "Edit OFFSITE",
  "editProject": "Edit Project",
  "editProjectGroup": "Edit project group",
  "editProjectTemplate": "Edit Project Template",
  "editProjectTemplateDraft": "Edit Project Template DRAFT",
  "editRepository": "Edit repository",
  "editSampleName": "Edit sample: {{name}}",
  "editSheet": "Edit Sheet {{name}}",
  "editStandardAction": "Edit Standard Action",
  "editTask": "Edit task",
  "editTeam": "Edit team",
  "edited": "Edited",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "Email cannot contain '..'",
  "emailLabel": "Email",
  "endDate": "End date",
  "enterSimulationMode": "Enter Simulation Mode",
  "errors": "Errors",
  "errorsProcessingRepository": "There were errors processing this repository",
  "estimatedWorkloadOneWeek": "Estimated workload one week: ",
  "exclusive": "Exclusive",
  "exclusiveSampleIndicator": "* Indicates an exclusive sample",
  "exitSimulation": "EXIT SIMULATION",
  "exitSimulationMode": "Exit simulation mode",
  "expand": "Expand",
  "exportToExcel": "Export to Excel",
  "fail": "Fail",
  "failSample": "Fail Sample",
  "failSelected": "Fail Selected",
  "failedLoading": "Failed loading: {{members}}",
  "failedToCreateMaintenance": "Failed to create maintenance \"{{name}}\"",
  "failedToDeleteMaintenance": "Failed to delete maintenance \"{{name}}\"",
  "failedToMarkMaintenanceAsCompleted": "Failed to mark maintenance \"{{name}}\" as completed",
  "failedToUpdateMaintenance": "Failed to update maintenance \"{{name}}\"",
  "failedUploads": "Failed Uploads",
  "fileUpload": "File Upload",
  "fileUploadError": "An error occurred during file upload",
  "filenameLabel": "Filename: ",
  "filesUploadedSuccessfully": "Files uploaded successfully",
  "fillIn": "Fill In",
  "fillInIgnoreOverbooking": "Fill In Ignore Overbooking",
  "filter": "Filter",
  "filterByName": "Filter by Name",
  "filterBySampleName": "Filter by Sample Name",
  "filterBySampleProductName": "Filter by Sample/Product Name",
  "filterByText": "Filter by Text",
  "finished": "Finished",
  "flag": "Flag",
  "flagSample": "Flag Sample",
  "followingErrorsWhileImporting": "Following errors while importing:",
  "free": "Free",
  "from": "From",
  "fromDate": "From date",
  "fromTime": "From time (HH:MM)",
  "fromTimeHH": "From time (HH)",
  "fromTimeHHMM": "From time (HH:MM)",
  "futureAnalysisTaskCantBe": "A future Analysis task can't be {{state}}",
  "generate": "Generate",
  "globalChatbot": "Global chatbot",
  "goBack": "Go back",
  "goBackToChat": "Go back to chat",
  "greyTaskTimePercentage": "Percentage of grey task time relative to total time (G2T)",
  "groupMembers": "Group Members",
  "groupName": "Group Name",
  "help": "Help",
  "helpBackToApp": "Back to app",
  "helpHome": "Help home",
  "helpPageNotFound": "Help page not found",
  "helpSearch": "Search help",
  "helpAppTitle": "Plannertech Help",
  "hidden": "Hidden",
  "hideMore": "Hide more",
  "highestPriority": "1 is highest priority",
  "history": "History",
  "home": "Home",
  "hour": "hour",
  "iCalendarOutlookIntegration": "iCalendar / Outlook Integration",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignore All Greytasks",
  "ignoredByIap": "Ignored by IAP",
  "includingToday": "Including today",
  "importedTask": "Imported task",
  "busyOnAnotherTeam": "Busy on another team",
  "includeDoneSamples": "Include done samples",
  "includeOverdue": "Include Overdue",
  "includeToday": "Include Today",
  "iapIncludeTodayWarningIAP": "Warning IAP and Include Today - tasks planned earlier today can also be moved unless they are locked!",
  "iapIncludeTodayWarningFillIn": "Warning Fill In and Include Today - tasks planned earlier today can also get new samples allocated!",
  "initials": "Initials",
  "inputLastMonth": "Input Last Month",
  "inputThisMonth": "Input This Month",
  "instrument": "Instrument",
  "instrumentConstraints": "Instrument Constraints",
  "instrumentLog": "Instrument Log",
  "instrumentName": "Instrument Name",
  "instrumentOffset": "Instrument offset (HH:MM)",
  "instrumentOverbooking": "Instrument Overbooking",
  "instrumentPerSampleDuration": "Instrument per sample duration (HH:MM:SS)",
  "instrumentSetup": "Instrument Setup {{name}}",
  "instrumentSetuptime": "Instrument setuptime (HH:MM)",
  "instrumentTime": "Instrument Time",
  "instrumentView": "Instrument View",
  "instruments": "Instruments",
  "instrumentsWithExpiredMaintenance": "There are instruments with expired maintenance",
  "instrumentsWithMaintenanceReminders": "There are instruments with maintenance reminders",
  "integration": "Integration",
  "invalidDate": "Invalid Date",
  "invalidOutlookLink": "Invalid iCalendar / Outlook link",
  "isInSimulationMode": "{{initials}} is in simulation mode",
  "isSimulating": "{{initials}} is simulating...",
  "keepExistingConnections": "Keep existing connections",
  "labelAlreadyLoaded": "Already loaded: {{count}}",
  "labelCreated": "Created: {{count}}",
  "labelDeleted": "Deleted: {{count}}",
  "labelDeletedOrFinished": "Deleted or marked as finished: {{count}}",
  "labelDoneDeleted": "Done/Deleted: {{count}}",
  "labelUpdatedInformation": "Updated information: {{count}}",
  "lastErrorLog": "Last Error Log",
  "lastWeek": "Last Week",
  "latestArrival": "Latest Arrival",
  "leadTimesInWorkDays": "Lead Times in Work Days",
  "leaveEmptyIfNotUsed": "(leave empty if not used)",
  "leaveEmptyIfNotUsedDefault": "(leave empty if not used, default={{defaultValue}})",
  "loadFromTemplate": "Load from template",
  "loading": "LOADING",
  "loadingEllipsis": "Loading...",
  "loadingSamples": "Loading samples",
  "loadingSheet": "Loading sheet",
  "loadingSheets": "Loading sheets",
  "location": "Location",
  "locationColon": "Location: {{name}}",
  "locationName": "Location Name",
  "lockItemType": "Lock {{itemType}}",
  "lockSamples": "Lock samples",
  "lockUnlockSamplesLabel": "Lock/Unlock samples:",
  "locks": "Locks",
  "locksAllFutureAnalysisTasks": "Locks all future planned analysis tasks",
  "locksAllFutureProjectActions": "Locks all future planned project actions",
  "login": "Login",
  "logout": "Logout",
  "maintenanceCreatedSuccessfully": "Maintenance \"{{name}}\" created successfully",
  "maintenanceDeletedSuccessfully": "Maintenance \"{{name}}\" deleted successfully",
  "maintenanceExpired": "Maintenance expired",
  "maintenanceExpiresInDays": "Maintenance expires in less than {{days}} days",
  "maintenanceMarkedAsCompleted": "Maintenance \"{{name}}\" marked as completed",
  "maintenanceName": "Maintenance name",
  "maintenanceUpdatedSuccessfully": "Maintenance \"{{name}}\" updated successfully",
  "mandatoryIfRecurrenceUsed": "(mandatory if recurrence is used)",
  "manualSample": "Manual sample",
  "manualSheetConfiguration": "Manual Sheet Configuration",
  "markAsDone": "Mark as done",
  "maxSampleCount": "Max Sample Count",
  "maxSampleCountLabel": "Max. sample count: ",
  "maxTimeBetweenActions": "Maximum time between actions (DD:HH:MM)",
  "maxTimeBetweenTasks": "Maximum time between tasks (DD:HH:MM)",
  "member": "Member",
  "memberHasEnabledICalendarOutlookIntegration": "Member Has Enabled iCalendar / Outlook Integration",
  "memberHasEnabledOutlook": "Member Has Enabled iCalendar / Outlook Integration",
  "memberPermissions": "Member permissions",
  "memberPlan": "Member Plan",
  "memberTime": "Member Time",
  "membersGoDirectlyToMemberPlan": "Members go directly to member plan",
  "message": "Message",
  "metric": "Metric",
  "minSampleCount": "Min Sample Count",
  "minSampleMustBeLowerThanMax": "Min sample count must be lower than max sample count",
  "minTimeBetweenActions": "Minimum time between actions (DD:HH:MM)",
  "minTimeBetweenTasks": "Minimum time between tasks (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "Minimum time between must be smaller than maximum time between",
  "minimumDuration": "Minimum Duration: {{time}}",
  "minute": "minute",
  "missingPasswordRequirements": "Missing password requirements: {{requirements}}",
  "months": "Months",
  "movedBy": "Moved By",
  "movedFrom": "Moved From",
  "movedTo": "Moved To",
  "mustBeIcsLink": "Must be a .ics link",
  "name": "Name",
  "namePerformer": "{{name}} performer",
  "nameTooLongTitle": "Name too long (max is 100 characters)",
  "newAnalysisTaskBundle": "New Analysis Task Bundle",
  "newChat": "New chat",
  "newInstrument": "New Instrument",
  "newProject": "New Project",
  "newProjectTemplateDraft": "New Project Template DRAFT",
  "newStart": "New Start",
  "nextDay": "Next Day",
  "nextWeek": "Next Week",
  "no": "No",
  "noAnalysesForProduct": "No analyses found for this product.",
  "noAssetsFound": "No assets found",
  "noChanges": "No changes",
  "noChatbotSelected": "No chatbot selected",
  "noDataFound": "No data found",
  "noErrorsToDisplay": "No errors to display.",
  "noGroup": "No group",
  "noMembersLoaded": "No members were loaded.",
  "noOfRecurrences": "No. of Recurrences",
  "noReferencesAvailable": "No references available.",
  "noSamples": "No samples",
  "noSamplesAvailable": "No samples available",
  "noSearchResults": "No search results",
  "noTimeLimitUnlessSpecified": "No time limit unless specified",
  "none": "None",
  "default": "Default",
  "notAvailable": "N/A",
  "notEnoughRoomForDuration": "Not enough room for the duration",
  "notStarted": "Not Started",
  "numberOfObservations": "Number of Observations",
  "numberOfRecurrences": "Number of recurrences",
  "numericInputBetweenTimeRange": "Please give a numeric input between 00:00 and 23:59",
  "offsiteCalendar": "OFFSITE Calender",
  "ok": "Ok",
  "oldInstrument": "Old Instrument",
  "oldStart": "Old Start",
  "onlyAdvancedUsersInfo": "Only advanced users use both earliest start and connections",
  "onsite": "Onsite",
  "openReferences": "Open References",
  "operationalGreyTaskTimePercentage": "Percentage of operational grey task time relative to total time (OG2T)",
  "operationalTask": "Operational Task",
  "otherPlannerSimulating": "{{initials}} is in simulation mode",
  "outlookLinkLabel": "iCalendar / Outlook Link",
  "outputLastMonth": "Output Last Month",
  "outputThisMonth": "Output This Month",
  "parentColumn": "Parent Column",
  "password": "Password",
  "paused": "Paused",
  "peopleSetup": "People Setup",
  "perSampleDuration": "Per sample duration (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Per Sample Duration for People Setup",
  "performerConstraintsCount": "Performer Constraints Count",
  "performerConstraintsLabel": "Performer Constraints",
  "permanentApiToken": "Permanent API token",
  "permanentApiTokenDescription": "This is a permanent API token, which allows you to access your team via our API. Copy and store it in a save place.",
  "pinConversation": "Pin conversation",
  "planned": "Planned",
  "planner": "Planner",
  "plannertechLanguage": "Plannertech language",
  "plannertechVariable": "Plannertech Variable",
  "pleaseChooseColor": "Please choose a Color for the analysis",
  "pleaseFillOutAnalysisName": "Please fill out the Analysis Name",
  "pleaseFillOutRequiredTaskParams": "Please fill out required task parameters",
  "pleaseGiveEmptyOrFullInput": "Please give empty or full input",
  "pleaseGiveNumericInput": "Please give numeric input",
  "pleaseInputValidDate": "Please input a valid date",
  "pleaseSelectAtLeastOneItem": "Please select at least one item",
  "pleaseSelectColor": "Please select a color",
  "pleaseSelectFirstDay": "Please select the first day.",
  "pleaseSelectLastDay": "Please select the last day.",
  "pleaseSelectTimezone": "Please select a timezone",
  "previousDay": "Previous Day",
  "primary": "Primary",
  "primaryInstrument": "Primary Instrument",
  "prioritizeByDeadline": "Prioritize IAP by Deadline",
  "prioritizeByPriority": "Prioritize IAP by Priority Number",
  "priority": "Priority",
  "priorityHigh": "(High)",
  "priorityLow": "(Low)",
  "priorityMedium": "(Medium)",
  "process": "Process",
  "processed": "Processed",
  "processing": "Processing...",
  "processingInProgress": "Processing",
  "productName": "Product Name",
  "project": "Project",
  "projectActions": "project actions",
  "projectBatchNumber": "Project Batch Number",
  "projectDeadline": "Project Deadline",
  "projectDescription": "Project Description",
  "projectEarliestStart": "Project Earliest Start",
  "projectGroup": "Project group",
  "projectGroupName": "Project group Name",
  "projectImport": "Project Import",
  "projectImportVariable": "Project Import Variable",
  "projectMaterialDescription": "Project Material Description",
  "projectMaterialNumber": "Project Material Number",
  "projectName": "Project Name",
  "projectPriority": "Project Priority",
  "projectReleaseDate": "Project Release Date",
  "projectSupplierName": "Project Supplier Name",
  "projectSupplierNumber": "Project Supplier Number",
  "projectTemplate": "project template",
  "projectTemplates": "Project Templates",
  "projectTimePercentage": "Percentage of project-time relative to total time (P2T)",
  "projectView": "Project View",
  "projects": "Projects",
  "projectsAndActions": "Projects & Actions",
  "promptPrefix": "Prompt Prefix",
  "promptTooLongTitle": "Prompt too long (max is 1200 characters)",
  "publish": "PUBLISH",
  "publishSimulationChanges": "Publish simulation mode changes",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Recur",
  "recurEvery": "Recur every",
  "recurrence": "Recurrence",
  "reduce": "Reduce",
  "references": "References",
  "rejectedFileTypes": "Rejected File Types",
  "rejectedFilesIncompatible": "The following files were rejected due to incompatible formats",
  "reminderDaysBeforeEndDate": "Reminder (days before end date)",
  "remove": "Remove",
  "removeAnalysisFromProduct": "Remove {{name}} from this product",
  "removeAsset": "Remove Asset",
  "removeEverything": "Remove everything",
  "removeInstrument": "Remove Instrument",
  "reportGenerator": "Report Generator",
  "reports": "Reports",
  "repositories": "Repositories",
  "repositoryCurrentlyProcessing": "The repository is currently processing the files. Please refresh the page to see the progress",
  "repositoryHasUnprocessedFiles": "This repository has unprocessed files",
  "repositoryIsProcessed": "This repository is processed",
  "repositoryName": "Repository Name",
  "reset": "Reset",
  "role": "Role",
  "row": "Row",
  "rowNumber": " row {{row}}",
  "runIAP": "Run IAP",
  "runningIAP": "Running IAP",
  "sampleAnalysisName": "Sample Analysis Name",
  "sampleBatchNumber": "Sample Batch Number",
  "sampleHighestPriority": "The sample has highest priority",
  "sampleId": "Sample ID",
  "sampleIdWithValue": "Sample ID: {{id}}",
  "sampleImport": "Sample Import",
  "sampleImportVariable": "Sample Import Variable",
  "sampleInProgressOnDoneAnalysis": "Sample in progress on done analysis",
  "sampleIsDone": "The sample is done",
  "sampleLog": "Sample Log",
  "sampleLowestPriority": "The sample has lowest priority",
  "sampleMaterialNumber": "Sample Material Number",
  "sampleName": "Sample Name",
  "sampleObservation": "Sample Observation",
  "sampleObservations": "Sample Observations",
  "samplePercentage": "Sample percentage",
  "sampleProductDescription": "Sample Product Description",
  "sampleReceivedDate": "Sample Received Date",
  "sampleStatus": "Sample Status",
  "sampleView": "Sample View",
  "samples": "Samples",
  "samplesWithName": "Samples with the name {{name}}",
  "samplesWithoutProduct": "Samples without product",
  "save": "Save",
  "saveAs": "Save As",
  "saveAsDraft": "Save as {{type}} DRAFT",
  "saveAsNew": "Save as new",
  "saveAsNewAnalysis": "Save as new analysis",
  "saveAsNewTemplate": "Save as new template",
  "saveAsType": "Save as {{type}}",
  "scrollToTop": "Scroll to top",
  "scrumView": "Scrum View",
  "scrumViewOrdering": "Scrum View Ordering",
  "searchBySampleName": "Search by sample name...",
  "searchCountry": "Search country",
  "seats": "Seats",
  "second": "second",
  "secondaryInstrumentMustHaveAllowedInstrument": "Secondary instrument setup must have at least one allowed instrument",
  "selectAll": "Select All",
  "selectChatbot": "Select chatbot",
  "selectDefaultChatbot": "Select default chatbot",
  "selectEntireDay": "Select entire day",
  "selectEntireWorkday": "Select entire workday",
  "selectLocation": "Select location...",
  "selectSamples": "Select Samples",
  "selectState": "Select state...",
  "selectTimezone": "Select timezone...",
  "selectType": "Select Type",
  "selectedFilesReadyForSubmit": "Selected files/folders ready for submit:",
  "selectedProduct": "Selected Product",
  "setPlannedValues": "Set Planned Values",
  "settings": "Settings",
  "settingsForQcLibrarian": "Settings for QC Librarian",
  "setupTimeForPeopleSetup": "Setup Time for People Setup",
  "setuptime": "Setuptime (HH:MM)",
  "sheetName": "Sheet Name",
  "sheetNameLabel": "Sheet Name",
  "sheetType": "Sheet Type",
  "shouldBeEqualTo": "should be equal to",
  "shouldNotBeEqualTo": "should not be equal to",
  "showAnalyses": "Show Analyses",
  "showErrors": "Show Errors",
  "showLastErrorLog": "Show last error log",
  "showLibrarian": "Show Librarian",
  "showLog": "Show Log",
  "showMore": "Show more",
  "showOnPlan": "Show on Plan",
  "showProjects": "Show Projects",
  "shown": "Visible",
  "simulationMode": "Simulation Mode",
  "simulationModeLogoutWarning": "You are currently in simulation mode. Logging out will discard changes!",
  "simulationModeOccupied": "SIMULATION MODE OCCUPIED",
  "simulationModeUpper": "SIMULATION MODE",
  "somethingWentWrong": "Something went wrong",
  "sortByProduct": "Sort by product",
  "sortByTime": "Sort By Time",
  "sortByTimeDescription": "Orders Backlog and To Do actions after their deadlines, and Planned and Finished after their starting time",
  "speechToTextLanguage": "Speech-to-text language",
  "spreadsheetColumnName": "Spreadsheet Column Name",
  "stage": "Stage",
  "standardActions": "Standard Actions",
  "start": "Start",
  "startDate": "Start Date",
  "startDateCheckboxInfo": "When checked project deadline, action deadline and action start will move relative to project start",
  "startEndDate": "Start/End Date",
  "startProcessingInfo": "This will start the processing of the repository. It may take a while depending on the size of the repository",
  "startRecurrence": "Start Recurrence",
  "startTime": "Start Time",
  "started": "Started",
  "state": "State",
  "status": "Status",
  "submit": "Submit",
  "successfullyLoaded": "Successfully loaded: {{members}}",
  "successfullyUploadedFiles": "Successfully Uploaded Files",
  "systemPrompt": "System prompt",
  "taskBelongsToTeam": "Task belongs to team: {{team}}",
  "taskCount": "Task Count",
  "taskDesignTool": "Task Design Tool",
  "taskLog": "Task Log",
  "taskName": "Task Name",
  "taskPerformerConstraints": "Task Performer Constraints",
  "tasks": "Tasks",
  "team": "Team",
  "teamChatbot": "Team chatbot",
  "teamLabel": "Team: {{name}}",
  "teamMember": "Team Member",
  "teamName": "Team Name",
  "teamPlan": "Team Plan",
  "teamUsageTitle": "{{name}} usage",
  "teams": "Teams",
  "templateIsDraft": "This project template is a Draft",
  "templateName": "Template Name",
  "theProjectIsDone": "The project is done",
  "timeConstraints": "Time Constraints",
  "timeHHMM": "Time (HH:MM)",
  "timePeriod": "Time Period",
  "timestamp": "Timestamp",
  "timezone": "Timezone",
  "to": "To",
  "toConfirmDeletionType": "To confirm deletion type {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "To confirm deletion type {{keyword}} and press confirm. This will permanently delete the test data, even with simulation mode. There is no going back.",
  "toConfirmDeletionTypeKeyword": "To confirm deletion type {{keyword}} and press confirm",
  "toDate": "To date",
  "toDo": "To Do",
  "toTime": "To time (HH:MM)",
  "toTimeHH": "To time (HH)",
  "toTimeHHMM": "To time (HH:MM)",
  "today": "Today",
  "tokens": "Tokens",
  "total": "Total",
  "normalSeats": "Normal",
  "tryReloadingOrContactSupport": "Try reloading, or contact support if the problem persists!",
  "type": "Type",
  "typeBeforeConfirming": "type {{keyword}} before confirming",
  "typeOrSelect": "Type or select...",
  "typeYourMessage": "Type your message...",
  "unassignedSamples": "Unassigned samples",
  "unassignedSamplesFor": "Unassigned samples for \"{{name}}\"",
  "unflag": "Unflag",
  "unflagSample": "Unflag Sample",
  "unlockItemType": "Unlock {{itemType}}",
  "unlockSamples": "Unlock samples",
  "unlocks": "Unlocks",
  "unlocksAllFutureAnalysisTasks": "Unlocks all future planned analysis tasks",
  "unlocksAllFutureProjectActions": "Unlocks all future planned project actions",
  "unnamed": "unnamed",
  "unpinConversation": "Unpin conversation",
  "unplan": "Unplan",
  "unplanAnalysis": "Unplan Analysis",
  "unplanItemType": "Unplan {{itemType}}",
  "unplanSample": "Unplan Sample",
  "unplanSelected": "Unplan Selected",
  "unplanned": "Unplanned",
  "unplannedProjects": "Unplanned Projects",
  "unsavedChangesIn": "There are unsaved changes in:",
  "updateIntegration": "Update Integration",
  "updatedIcalOutlook": "Updated iCalendar / Outlook!",
  "uploadAborted": "Upload aborted!",
  "uploadComplete": "Upload complete!",
  "uploadFailedForFile": "Upload failed for file: {{path}}",
  "uploadFinished": "Upload Finished!",
  "uploadTo": "Upload to {{name}}",
  "usage": "Usage",
  "used": "Used",
  "usedAssets": "Used Assets",
  "usedInstrument": "Used Instrument",
  "usedInstruments": "Used Instruments",
  "username": "Username",
  "value": "Value",
  "view": "View",
  "viewAllAnalysesForProduct": "View all analyses for this product",
  "viewAnalysisSamples": "View Analysis Samples",
  "viewCompact": "View Compact",
  "viewNormal": "View Normal",
  "weekNumber": "Week {{week}}",
  "weekView": "Week View",
  "dayView": "Day View",
  "weekendView": "Weekend View",
  "screen": "Screen",
  "clickToSortBy": "Click to sort by {{column}}",
  "fileChangedPleaseReselect": "{{file}} has changed. Please select the file again",
  "contentTooWideZoomOut": "The content is too wide for the screen. For a better viewing experience, zoom out ({{key}} +/-)",
  "week": "Week",
  "weekly": "Weekly",
  "weeks": "week(s)",
  "withConnections": "with connections",
  "workHours": "Work Hours",
  "workWeek": "Work Week",
  "years": "Years",
  "yes": "Yes",
  "youAreInSimulationMode": "You are in simulation mode",
  "zeroHours": "0 hours",
  "addCustomer": "Add customer",
  "addGlobalChatbot": "Add global chatbot",
  "addGlobalRepository": "Add global repository",
  "apiKey": "API Key",
  "authenticationCode": "Authentication Code",
  "authenticationCodeSentInfo": "We have sent an authentication code to your email. Please enter it above before login",
  "chatbotPrefix": "Chatbot prefix",
  "chatbotSystemPrompt": "Chatbot System Prompt",
  "chatbotSystemPrompts": "Chatbot System Prompts",
  "citationGuidelines": "Citation guidelines",
  "configureMember": "Configure Member",
  "createApiKey": "Create API key",
  "creatingProject": "Creating Project",
  "currentQuestion": "Current question",
  "customerAdminApiKeyForGlobalRepositories": "Customer Admin API key for Global Repositories",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "Delete API key",
  "descriptionPrompt": "Description Prompt",
  "editGlobalMessage": "Edit Global Message",
  "editingProject": "Editing Project",
  "editSystemPrompts": "Edit System Prompts",
  "filePathPrompt": "File Path Prompt",
  "fillingInSamples": "Filling in samples",
  "generalPrefix": "General prefix",
  "globalChatbots": "Global Chatbots",
  "globalRepositories": "Global Repositories",
  "hideNextWeek": "Hide Next Week",
  "hideSatSun": "- Sat/Sun",
  "manageAdmins": "Manage Admins",
  "oneWeek": "1 Week",
  "openMetricsPanel": "Open Metrics/IAP Panel",
  "openTodoList": "Open TODO List",
  "optimizedQuestionPrompt": "Optimized question prompt",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Plannertech Team Plan",
  "previousConversation": "Previous conversation",
  "librarianLogoAlt": "Librarian logo",
  "qcLibrarianForCompany": "{{company}} QC Librarian",
  "relevantDocumentation": "Relevant documentation",
  "repositoryHasUnprocessedFilesInfo": "There are unprocessed files in this repository",
  "repositoryIsEmpty": "This repository is empty",
  "repositoryPrefix": "Repository prefix",
  "repositoryProcessingInProgressInfo": "The repository is currently processing the files. Please refresh the page to see the progress",
  "sampleAllocation": "Sample allocation",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Seats: {{count}}",
  "excludingToday": "Excluding today",
  "unplanning": "Unplanning",
  "totalSeats": "Total seats: {{count}}",
  "purchasedSeats": "Purchased seats: {{count}}",
  "membersPlanners": "Members/planners: {{count}}",
  "viewOnlySeats": "View-only: {{count}}",
  "viewOnly": "View-only",
  "totalSeatsLabel": "Total seats",
  "membersPlannersLabel": "Members/planners",
  "globalMessage": "Global Message",
  "clearGlobalMessageConfirm": "Are you sure you want to clear the global message? This will make it disappear for all users.",
  "samplesCount": "Samples: {{count}}",
  "locations": "Locations",
  "customers": "Customers",
  "editCustomer": "Edit customer",
  "addCustomerTitle": "Add Customer",
  "deleteCustomer": "Delete Customer",
  "customerName": "Customer Name",
  "customerStatus": "Customer status",
  "active": "Active",
  "passive": "Passive",
  "allowedDomains": "Allowed Domains",
  "allowedPerformers": "Allowed performers",
  "seatsPurchased": "Seats purchased",
  "customerApiKey": "Customer API key",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Continue",
  "showNextWeek": "Show Next Week",
  "showSatSun": "+ Sat/Sun",
  "topDescriptionPrompt": "Top description prompt",
  "twoWeeks": "2 Weeks",
  "updateHelpPage": "Update Help Page",
  "userAlreadyLoggedInTakeOver": "User already logged in. To take over session press confirm",
  "zoomIn": "Zoom in",
  "zoomOut": "Zoom out",
  "constraintWarningTitle": "{{count}} warning(s) has occurred",
  "assetStatusFree": "Free",
  "assetStatusBooked": "Booked",
  "dateTo": "to",
  "futureAnalysisTaskCantBeFinished": "A future Analysis task can't be finished",
  "tableNotFound": "Table not found",
  "conversionSheetFilename": "Conversion Sheet.xlsx",
  "back": "Back",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Customer Admin",
  "attachFile": "Attach file",
  "removeFile": "Remove file",
  "fileTooLarge": "File is too large (max 10 MB)",
  "tooManyFiles": "Maximum 3 files per message",
  "unsupportedFileType": "Unsupported file type. Allowed: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
